import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import {select, Store} from "@ngrx/store";
import { Dashboard } from 'src/app/state/dashboard';
import { DashboardSelector } from 'src/app/state/dashboard.selector';
import { AppService } from 'src/app/app.service';
@Component({
  selector: 'app-tiles',
  templateUrl: './tiles.component.html',
  styleUrls: ['./tiles.component.scss']
})
export class TilesComponent implements OnInit {

   @Input('userRole') userRole:string|any;
  datas$: Observable<Dashboard> = this.store.pipe(select(DashboardSelector));

  public currency: string;

  constructor(private store: Store, private appService: AppService) { }

  ngOnInit(): void {
    
    this.currency = this.appService.getCurrency();
    
  }

}
